import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  success?: boolean;
  helperText?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  success,
  helperText,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
  
  const baseClasses = 'w-full px-4 py-2.5 border rounded-lg font-body text-body text-text-dark placeholder:text-body-grey focus:outline-none focus:ring-2 focus:ring-offset-0 transition-all duration-200';
  
  const stateClasses = error 
    ? 'border-red-500 focus:border-red-500 focus:ring-red-200' 
    : success 
    ? 'border-green-500 focus:border-green-500 focus:ring-green-200'
    : 'border-gray-300 focus:border-brand-blue focus:ring-brand-blue/20';
  
  return (
    <div className="space-y-1">
      {label && (
        <label 
          htmlFor={inputId} 
          className="block text-label font-body font-medium text-text-dark"
        >
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={`${baseClasses} ${stateClasses} ${className}`}
        {...props}
      />
      {(error || helperText) && (
        <p className={`text-label font-body ${error ? 'text-red-500' : 'text-body-grey'}`}>
          {error || helperText}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
